<rect width="32" height="32" fill="currentColor" rx="16" />
<path
    fill="var(--gw-rd-white-color)"
    d="M20.112 16.145h-2.817V26h-4.257v-9.855H11v-3.58h2.038v-2.328c0-1.67.78-4.237 4.256-4.237h3.118v3.461h-2.278c-.36 0-.9.18-.9.955v2.089h3.178l-.3 3.64Z"
/>
